import { Icon } from '@iconify/react';

const DeleteJournalModal = ({ entry, onClose, onConfirm, loading }) => {
    if (!entry) return null;

    return (
        <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/40" onClick={() => !loading && onClose()}>
            <div className="tw-bg-white tw-rounded-lg tw-shadow-xl tw-w-full tw-max-w-sm tw-mx-4" onClick={(e) => e.stopPropagation()}>
                <div className="tw-px-5 tw-py-4 tw-text-center">
                    <div className="tw-mx-auto tw-w-10 tw-h-10 tw-rounded-full tw-bg-red-50 tw-flex tw-items-center tw-justify-center tw-mb-3">
                        <Icon icon="mdi:delete-alert-outline" className="tw-text-red-500 tw-text-xl" />
                    </div>
                    <h3 className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-flex tw-items-center tw-justify-center tw-gap-1">
                        <Icon icon="mdi:file-document-remove-outline" className="tw-text-red-400 tw-text-base" />
                        Delete Journal Entry
                    </h3>
                    <p className="tw-text-xs tw-text-gray-500 tw-mt-1">
                        Are you sure you want to delete journal entry <strong>#{entry.id}</strong>?
                        This action cannot be undone.
                    </p>
                    {entry.remarks && (
                        <p className="tw-text-[10px] tw-text-gray-400 tw-mt-2 tw-italic tw-flex tw-items-center tw-justify-center tw-gap-1">
                            <Icon icon="mdi:format-quote-open" className="tw-text-xs tw-text-gray-300" />
                            {entry.remarks}
                            <Icon icon="mdi:format-quote-close" className="tw-text-xs tw-text-gray-300" />
                        </p>
                    )}
                </div>
                <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-3 tw-border-t tw-border-gray-100">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded tw-text-xs tw-font-medium tw-text-gray-700 tw-bg-gray-100 hover:tw-bg-gray-200 disabled:tw-opacity-50"
                    >
                        <Icon icon="mdi:close" className="tw-text-sm" />
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded tw-text-xs tw-font-medium tw-text-white tw-bg-red-600 hover:tw-bg-red-700 disabled:tw-opacity-50"
                    >
                        {loading ? (
                            <div className="tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-white tw-border-t-transparent"></div>
                        ) : (
                            <Icon icon="mdi:trash-can-outline" className="tw-text-xs" />
                        )}
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteJournalModal;
